module.exports = __webpack_public_path__ + "static/media/van-life-crime.fe96b2da.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/article-images/van-life-crime.webp
// module id = 110
// module chunks = 0